import { Dialog } from 'primereact/dialog';
import { useTranslation } from 'react-i18next';

import { MediaTypeModalProps } from '@features/campaigns/list/components/MediaType/Modal/MediaTypeModal.tsx';
import { MediaTypePanel } from '@features/campaigns/list/components/MediaType/Panel/MediaTypePanel.tsx';
import { CampaignMediaTypes } from '@features/campaigns/shared/types/campaign.ts';
import { ICON_VARIANTS } from '@shared/components/Icon/IconMapper.ts';
import { DefaultActionsFooter } from '@shared/components/Modal/Footers/DefaultActionsFooter/DefaultActionsFooter';
import { i18nNameSpace } from '@shared/consts/i18n';

import styles from './CampaignTypeModal.module.scss';

export function CampaignTypeModal({
  isVisible,
  toggleModalVisibility,
  setSelectedMediaType,
  selectedMediaType,
  submitCallback,
}: MediaTypeModalProps) {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);

  return (
    <Dialog
      visible={isVisible}
      onHide={toggleModalVisibility}
      draggable={false}
      resizable={false}
      header={t('builder.modals.headers.selectCampaignType')}
      footer={
        <DefaultActionsFooter
          cancelLabel={t('builder.modals.cancel')}
          cancelCallback={toggleModalVisibility}
          submitLabel={t('builder.modals.next')}
          submitCallback={submitCallback}
        />
      }
    >
      <div className={styles.wrapper}>
        <MediaTypePanel
          mediaType={CampaignMediaTypes.CTV}
          illustrations={[
            {
              iconVariant: ICON_VARIANTS.lannerFormat,
              iconLabel: '',
              caption: t('builder.mediaTypes.selfServiceCtv.lannerLabel'),
            },
            {
              iconVariant: ICON_VARIANTS.videoFormat,
              iconLabel: '',
              caption: t('builder.mediaTypes.selfServiceCtv.videoLabel'),
            },
          ]}
          description={t('builder.mediaTypes.selfServiceCtv.description')}
          tags={[t('page.list.campaignFormat.display'), t('page.list.campaignFormat.video')]}
          isFullWidth
          changeHandler={setSelectedMediaType}
          isActive={selectedMediaType === CampaignMediaTypes.CTV}
        />
        <MediaTypePanel
          mediaType={CampaignMediaTypes.THEMATIC}
          illustrations={[{ iconVariant: ICON_VARIANTS.thematicPackages, iconLabel: '' }]}
          label={t('builder.mediaTypes.thematic.label')}
          description={t('builder.mediaTypes.thematic.description')}
          tags={[t('builder.mediaTypes.thematic.tag')]}
          isFullWidth
          isHorizontal
          changeHandler={setSelectedMediaType}
          isActive={selectedMediaType === CampaignMediaTypes.THEMATIC}
        />
      </div>
    </Dialog>
  );
}
